export default "__VITE_ASSET__Cmo1bgpO__"